import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { Collapse, Col } from 'antd';
import { flattenDocs } from '../../utils';
import { isNil } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { isAuditor, isCommittee } from 'utils';
import { ReactComponent as DownloadFile } from 'assets/icons/download_blue.svg';
import { downloadApplicationZip } from '../../../../../../../store/forms/actions';
import { Download, TextField, RadioGroup } from 'components';

const { Panel } = Collapse;

const DownloadedItems = ({ content, subgroupName, docs, subdocs, subgroup, docItems }) => {
  const dispatch = useDispatch();
  const userGroups = useSelector(state => state.user?.groups);
  const businessKey = useSelector(state => state.forms.businessKey);


  // Render files helper
  const renderFiles = (docList) => (
    <div className="file-download-container">
      {content.map((c, index) =>
        includes(
          docList.filter(d => d && d.field).map(d => d.field),
          c.fileCode
        ) ? (
          <Download
            key={index}
            description={c.label}
            file={docList.filter(d => d && d.field === c.fileCode)}
          />
        ) : null
      )}
    </div>
  );


  return (
    <div>
      {/* Render subgroup companies if applicable */}
      {subgroup === true && subgroupName === 'companies' ? (
        subdocs.map((item, index) => {
          const flatDocsCompanies = flattenDocs(item);

          return (
            <div key={index} className="companiesCollapse mb-1">
              <Collapse>
                <Panel
                  header={
                    <span>
                      {item.cmpNameAff
                        ? `${index + 1}. Στοιχεία Συνεργαζόμενης Επιχείρησης: ${item.cmpNameAff}`
                        : '-'}
                    </span>
                  }
                >
                  <div className="d-flex mb-2">
                    <Col span={5}>
                      <TextField
                        label="Νομική Μορφή"
                        bold
                        value={item.cmpDocslegalForm}
                        disabled
                      />
                    </Col>
                  </div>
                  <div className="d-flex mb-2">
                    <Col span={6}>
                      <RadioGroup
                        label="Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ"
                        options={[
                          { label: 'Μικρή', value: 'Μικρή', disabled: false },
                          { label: 'Μεσαία', value: 'Μεσαία', disabled: false },
                          { label: 'Μεγάλη', value: 'Μεγάλη', disabled: false },
                        ]}
                        bold
                        value={item.cmpCompanySize}
                        disabled
                      />
                    </Col>
                  </div>
                  <div className="d-flex mb-2">
                    <Col span={5}>
                      <TextField
                        label="Είδος Λογιστικών Βιβλίων"
                        bold
                        value={item.cmpTypeAccountingBooks}
                        disabled
                      />
                    </Col>
                  </div>
                  {renderFiles(flatDocsCompanies)}
                </Panel>
              </Collapse>
            </div>
          );
        })
      ) : (
        <>
          {!isNil(docItems?.typeAccountingBooks) && (
            <div className="mb-3">
              <Col span={14} className="mb-2">
                <TextField
                  label="Είδος Λογιστικών Βιβλίων"
                  bold
                  value={docItems.typeAccountingBooks}
                  disabled
                />
              </Col>
            </div>
          )}

          {!isNil(docItems?.contractAdmin) && (
            <div className="mt-4">
              <Col span={14} className="mb-2">
                <RadioGroup
                  label="Έχετε συνάψει σύμβαση για όρους σύνδεσης με αρμόδιο διαχειριστή (ΔΕΔΔΗΕ / ΑΔΜΗΕ);"
                  options={[
                    { label: 'Ναι', value: 'Ναι', disabled: false },
                    { label: 'Όχι', value: 'Όχι', disabled: false },
                  ]}
                  bold
                  value={docItems?.contractAdmin}
                  disabled
                />
              </Col>
            </div>
          )}

          {renderFiles(docs)}
        </>
      )}
    </div>
  );
};

DownloadedItems.propTypes = {
  content: PropTypes.array.isRequired,
  docs: PropTypes.array.isRequired,
  subdocs: PropTypes.array,
  subgroup: PropTypes.bool,
  subgroupName: PropTypes.string,
  docItems: PropTypes.object,
};

export default DownloadedItems;
